import { cn } from '@lib/utils.ts';
import { ZodFormattedError, ZodTypeAny } from 'zod';

type ErrorMessageProps = {
  className?: string;
  zodError?: ZodFormattedError<ZodTypeAny, string>;
  message?: string;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ className = '', zodError, message }) => {
  if (!message && !zodError) return null;
  const errorMessage = message || zodError?._errors?.[0];

  return <div className={cn('text-xs text-red-500', className)}>{errorMessage}</div>;
};
